<template>
	<div class="w-full body-bg">
		<div class="h-img-block"><img class="h-img" src="../assets/2.png" /></div>
		<div class="login">
			<div class="login-form">
				<div class="login-form_title">账号注册</div>
				<div>
					<label class="login-form-lable">登录名</label>
					<input class="login-form_item margin-top-29" placeholder="请设置账号名称，只允许输入汉字" name="userName" type="text"
						v-model="userName" onkeyup="value=value.replace(/[^\u4E00-\u9FA5]/g,'')" />
				</div>

				<div v-if="wUserName" class="font-wraing">
					<img class="wraing-icon" src="../assets/3.png" /><span>{{ wUserName }}
					</span>
				</div>
                <div v-else class="font-wraing">
					<span>* 登录名只允许输入汉字
					</span>
				</div>
				<div>
					<label class="login-form-lable">密码</label>
					<input class="login-form_item" name="paw" placeholder="请输入9~16位密码" type="password" v-model="paw" />
				</div>
				<div v-if="wPaw" class="font-wraing">
					<img class="wraing-icon" src="../assets/3.png" /><span>{{wPaw }}</span>
				</div>
				<div>
					<label class="login-form-lable">确认密码</label>
					<input class="login-form_item" name="newPaw" placeholder="请输入确认密码" type="password"
						v-model="newPaw" />
				</div>

				<div v-if="wNewPaw" class="font-wraing">
					<img class="wraing-icon" src="../assets/3.png" /><span>{{wNewPaw}}</span>
				</div>
				<div>
					<label class="login-form-lable">电子邮箱</label>
					<input class="login-form_item" name="email" placeholder="请输入电子邮箱" type="text" v-model="email" />
				</div>

				<div v-if="wEmail" class="font-wraing">
					<img class="wraing-icon" src="../assets/3.png" /><span>{{
            wEmail
          }}</span>
				</div>
				<div>
					<label class="login-form-lable">手机号</label>
					<input class="login-form_item" name="tel" placeholder="请输入手机号码" type="number" v-model="tel" />
				</div>

				<div v-if="wTel" class="font-wraing">
					<img class="wraing-icon" src="../assets/3.png" /><span>{{
            wTel
          }}</span>
				</div>
				<div class="pos-input">
					<div class="">
						<span class="login-form-lable">短信验证</span>
						<input class="login-form_item" name="code" type="number" placeholder="请输入短信验证码"
							v-model="code" />
					</div>
					<div v-show="show" @click="getCode" class="code-block">发送验证码</div>
					<div v-show="!show" class="code-block">{{count}} s</div>
				</div>
				<div v-if="wCode" class="font-wraing">
					<img class="wraing-icon" src="../assets/3.png" /><span>{{
            wCode
          }}</span>
				</div>

				<button class="login-but" @click="login">注册</button>
				<div class="login-link">
					<router-link to="/" >已有账号？请登录</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		IsName,
		IsPaw,
		IsCode,
		IsPawCompare,
		IsEmail,
		IsTel,
	} from "../utils/validate";
	import {
		Register,
		SendSms, //发送验证码
	} from "../utils/api.js"
	export default {
		name: "Register",
		components: {},
		data() {
			return {
				userName: "",
				wUserName: "", //用户名提示
				paw: "",
				wPaw: "", //密码提示
				code: "",
				wCode: "", //验证码提示
				newPaw: "",
				wNewPaw: "", //确认密码
				email: "",
				wEmail: "", //电子邮件
				tel: "",
				wTel: "", //手机号码
				pawRemember: false, //是否记住密码
				// 验证码
				show: true,
				count: '',
				timer: null,
			};
		},
		methods: {
			// 发送验证码
			getCode() {
				const TIME_COUNT = 60;
				const data = {
					phone: this.tel
				}
				if (IsTel(this, this.tel, "手机号码")) {
					SendSms(data).then(res => {
						console.log(res)
						if (!this.timer) {
							this.count = TIME_COUNT;
							this.show = false;
							this.timer = setInterval(() => {
								if (this.count > 0 && this.count <= TIME_COUNT) {
									this.count--;
								} else {
									this.show = true;
									clearInterval(this.timer);
									this.timer = null;
								}
							}, 1000)
						}
					}).catch(err => {
						this.$message.error(err);
					})
				}


			},
			onRegisterTap() {
				this.$router.push({
					name: "Register"
				});
			},
			login() {

				if (
					IsName(this, this.userName, "账户名称") &&
					IsPaw(this, this.paw, "登录密码") &&
					IsPawCompare(this, this.newPaw, "确认密码", this.paw) &&
					IsEmail(this, this.email, "电子邮箱") &&
					IsTel(this, this.tel, "手机号码") &&
					IsCode(this, this.code, "验证码")
				) {
					console.log("校验通过");
					const data = {
						"name": this.userName,
						"password": this.paw,
						"phone": this.tel,
						"email": this.email,
						"code": this.code
					}
					Register(data).then(res => {
						console.log(res)
						this.$message({
							message: '注册成功',
							type: 'success'
						});
                        this.$router.replace({
                            path: '/login',
                        });

					}).catch(err => {
						this.$message.error(err);
					})
				}
			},
		},
	};
</script>
<style lang="less" scoped>
	#app {
		width: 100%;
		height: 100%;
	}

	body {
		width: 100%;
		height: 100%;
	}

	.w-full {
		width: 100%;
		height: 100%;
	}

	.body-bg {
		background: url("../assets/1.png");
		background-size: cover;
		background-repeat: no-repeat;
		overflow: auto;
		height: 100%;

		.h-img-block {
			margin-top: 20px;
			text-align: center;

			.h-img {
				margin: 0 auto;
                width: 201px;
                height: 206px;
			}
		}

		.login {
			margin-top: 43px;

			.login-form {
				width: 658px;
				//  height: 473px;
				background: #fff;
				margin: 0 auto;
				padding: 20px 20px 40px 22px;

				.login-form-lable {
					display: inline-block;
					width: 60px;
					color: #757575;
					font-size: 14px;
					text-align: right;
				}

				&_title {
					color: #272f3c;
					font-size: 24px;
					font-weight: bold;
					line-height: 26px;
					text-align: left;
					border-bottom: 1px solid #dbdbdb;
					padding-bottom: 18px;
				}

				&_item {
					width: 280px;
					height: 42px;
					border: 1px solid #bdc3cb;
					padding: 0px 11px;
					font-size: 14px;
					margin-left: 12px;
					margin-top: 10px;
				}

				.margin-top-29 {
					margin-top: 29px;
				}

				.pos-input {
					position: relative;

					.margin-top-0 {
						margin-top: 0px;
					}

					.code-block {
						position: absolute;
						top: 10px;
						right: 140px;
						width: 102px;
						height: 42px;
						text-align: center;
						line-height: 42px;
						color: #3D63DF;
						border: 1px solid #3D63DF;
						font-size: 14px;
						cursor: pointer;
					}
				}

				.login-form_assist {
					width: 280px;
					//   height: 60px;
					//  line-height: 60px;
					margin-top: 15px;
					// margin-left: 32px;
					margin-bottom: 19px;
					vertical-align: middle;

					&_isAgree {
						display: inline-block;

						margin-right: 8px;
					}

					&_isAgree:checked::after {
						background: crimson;
					}

					a {
						float: right;
						text-decoration: underline;
						color: #71767c;
						font-size: 14px;
					}
				}

				.login-but {
					width: 302px;
					height: 48px;
					background: #194abe;
					opacity: 1;
					border-radius: 6px;
					// margin-left: 32px;
					color: #fff;
					font-size: 16px;
					font-weight: bold;
					border: none;
					cursor: pointer;

					margin-top: 37px;
				}

				.login-register {
					width: 280px;
					height: 48px;
					background: #ffffff;
					opacity: 1;
					border-radius: 6px;
					// margin-left: 32px;
					color: #194abe;
					font-size: 16px;
					font-weight: bold;
					margin-top: 24px;
					text-align: center;
					line-height: 48px;
					border: 1px solid #194abe;
					cursor: pointer;
					border-radius: 6px;
				}

				.font-wraing {
					color: #ff7476;
					font-size: 14px;
					margin-left: 210px;
					margin-top: 6px;
					text-align: left;
				}

				.wraing-icon {
					display: inline-block;
					margin-right: 10px;
				}
			}
		}

		.login-link {
			font-size: 16px;
			color: #194abe;
			margin-top: 14px;
			font-weight: 400;
		}
        .login-link a{
            color:#9FA6AF;
        }
	}
</style>
